(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const header = document.querySelector('.header');
    if (!header) return;

    window.addEventListener('scroll', function () {
      header.classList.toggle('header--scrolled', window.scrollY > 0);
    }, { passive: true });

    const burger = header.querySelector('.header__burger');
    const menu = header.querySelector('.header__menu');
    if (!burger || !menu) return;

    function setOpen(open) {
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      menu.classList.toggle('is-open', open);
    }

    burger.addEventListener('click', function (e) {
      e.stopPropagation();
      setOpen(burger.getAttribute('aria-expanded') !== 'true');
    });

    menu.addEventListener('click', function (e) {
      if (e.target.closest('a')) setOpen(false);
    });

    document.addEventListener('click', function (e) {
      if (!header.contains(e.target)) setOpen(false);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["riza-cart"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.querySelector('.riza-cart');
    if (!section) return;

    const root_url = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    function money(cents) {
      return 'R$ ' + (cents / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function syncHeaderCount(count) {
      document.querySelectorAll('.header__cart-count').forEach((el) => { el.textContent = '(' + count + ')'; });
      document.querySelectorAll('.header__cart-text').forEach((el) => {
        el.textContent = el.textContent.replace(/\(\d+\)/, '(' + count + ')');
      });
    }

    // Desabilita o "+" quando a linha atinge o estoque disponível (data-max)
    function syncStepper(input) {
      if (!input) return;
      const max = input.dataset.max ? parseInt(input.dataset.max, 10) : null;
      const val = parseInt(input.value, 10) || 0;
      const plus = input.parentElement.querySelector('.riza-cart__qty-btn[data-step="1"]');
      if (plus) plus.disabled = max !== null && val >= max;
    }

    // Aplica o estado do carrinho (vindo de change.js ou cart.js) na tela
    function renderCart(cart) {
      if (!cart || typeof cart.item_count === 'undefined') return false;
      if (cart.item_count === 0) { window.location.reload(); return true; }

      // Segurança: se algum item do carrinho não tem linha correspondente no
      // DOM (ex.: uma linha entrou/saiu do bloco de kit, ou a Shopify regenerou
      // a key ao recalcular o desconto), recarrega para o Liquid re-renderizar
      // tudo em vez de remover a linha por engano.
      const keysChanged = cart.items.some((it) => {
        return !section.querySelector('.riza-cart__item[data-line-key="' + it.key + '"]');
      });
      if (keysChanged) { window.location.reload(); return true; }

      const stillThere = {};
      cart.items.forEach((it) => {
        stillThere[it.key] = true;
        const priceEl = section.querySelector('.riza-cart__line-price[data-line-key="' + it.key + '"]');
        if (priceEl) priceEl.textContent = money(it.final_line_price);
        const qtyEl = section.querySelector('.riza-cart__qty-input[data-line-key="' + it.key + '"]');
        // Não sobrescreve enquanto o usuário digita no campo
        if (qtyEl && document.activeElement !== qtyEl) qtyEl.value = it.quantity;
        syncStepper(qtyEl);
      });

      // Remove as linhas que saíram do carrinho
      section.querySelectorAll('.riza-cart__item').forEach((row) => {
        if (!stillThere[row.dataset.lineKey]) row.remove();
      });

      const sub = section.querySelector('[data-cart-subtotal]');
      if (sub) sub.textContent = money(cart.total_price);
      syncHeaderCount(cart.item_count);
      return true;
    }

    // Busca o estado verdadeiro do carrinho (usado como fallback/re-sync)
    function resyncCart() {
      return fetch(root_url + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then((r) => r.json())
        .then(renderCart)
        .catch((err) => { console.error('[riza-cart] resync falhou:', err); });
    }

    // Kit: altera TODAS as linhas do grupo de uma vez (update.js aceita várias
    // linhas por chave). Mexer no kit remexe o desconto, então recarregamos
    // para o Liquid re-renderizar o bloco com a quantidade/preço corretos.
    function updateKit(keysStr, quantity, offsetsStr) {
      var keys = (keysStr || '').split(',').filter(function (k) { return k; });
      if (!keys.length) return;
      // Cada key recebe a quantidade do kit + a sobra daquela linha (offset),
      // pra mexer só na parte "do kit" e preservar o excedente já no carrinho.
      var offsets = (offsetsStr || '').split(',');
      var updates = {};
      keys.forEach(function (k, i) {
        var off = parseInt(offsets[i], 10) || 0;
        updates[k] = quantity + off;
      });
      fetch(root_url + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.reload(); })
        .catch(function (err) {
          console.error('[riza-cart] update.js (kit) falhou:', err);
          resyncCart();
        });
    }

    function changeLine(key, quantity) {
      fetch(root_url + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then((r) => r.json())
        .then((cart) => {
          // change.js devolve a resposta de erro quando algo dá errado
          // (ex.: limite de estoque, chave de linha inválida). Não engolir.
          if (!renderCart(cart)) {
            console.error('[riza-cart] change.js não retornou um carrinho válido:', cart);
            return resyncCart();
          }
        })
        .catch((err) => {
          console.error('[riza-cart] change.js falhou:', err);
          resyncCart();
        });
    }

    // Interações dos itens via delegação — sobrevive a re-render do DOM
    section.addEventListener('click', (e) => {
      const stepBtn = e.target.closest('.riza-cart__qty-btn');
      if (stepBtn) {
        const input = stepBtn.parentElement.querySelector('.riza-cart__qty-input');
        if (!input) return;
        const step = parseInt(stepBtn.dataset.step, 10);
        const min = parseInt(input.min, 10) || 0;
        const max = input.dataset.max ? parseInt(input.dataset.max, 10) : null;
        const current = parseInt(input.value, 10) || 0;
        let next = current + step;
        if (next < min) next = min;
        if (max !== null && next > max) next = max;
        if (next === current) return;
        input.value = next;
        syncStepper(input);
        if (input.dataset.lineKeys) {
          updateKit(input.dataset.lineKeys, next, input.dataset.lineOffsets);
        } else {
          // Linha de sobra: a key é compartilhada com o kit, então soma a base
          // (K) — assim mexe só no excedente. Linhas normais têm base 0.
          var base = parseInt(input.dataset.lineBase, 10) || 0;
          changeLine(input.dataset.lineKey, next + base);
        }
        return;
      }
      const removeBtn = e.target.closest('.riza-cart__remove');
      if (removeBtn) {
        if (removeBtn.dataset.lineKeys) {
          updateKit(removeBtn.dataset.lineKeys, 0, removeBtn.dataset.lineOffsets);
        } else {
          // Sobra: remover deixa a key em K (mantém o kit). Normal: base 0 → 0.
          var base = parseInt(removeBtn.dataset.lineBase, 10) || 0;
          changeLine(removeBtn.dataset.lineKey, base);
        }
      }
    });

    // Quantidade digitada
    section.addEventListener('change', (e) => {
      const input = e.target.closest('.riza-cart__qty-input');
      if (!input) return;
      const min = parseInt(input.min, 10) || 0;
      let q = Math.max(min, parseInt(input.value, 10) || min);
      const max = input.dataset.max ? parseInt(input.dataset.max, 10) : null;
      if (max !== null && q > max) q = max;
      input.value = q;
      syncStepper(input);
      if (input.dataset.lineKeys) {
        updateKit(input.dataset.lineKeys, q, input.dataset.lineOffsets);
      } else {
        var base = parseInt(input.dataset.lineBase, 10) || 0;
        changeLine(input.dataset.lineKey, q + base);
      }
    });

    // Estado inicial dos "+" conforme o estoque de cada linha
    section.querySelectorAll('.riza-cart__qty-input').forEach(syncStepper);

    // Frete
    const shipToggle = section.querySelector('.riza-cart__ship-toggle');
    const shipBody = section.querySelector('.riza-cart__ship-body');
    if (shipToggle && shipBody) {
      shipToggle.addEventListener('click', () => {
        const open = shipBody.hasAttribute('hidden');
        if (open) { shipBody.removeAttribute('hidden'); } else { shipBody.setAttribute('hidden', ''); }
        shipToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    const cep = section.querySelector('.riza-cart__cep');
    const calcBtn = section.querySelector('.riza-cart__ship-calc');
    const results = section.querySelector('.riza-cart__ship-results');

    if (cep) {
      cep.addEventListener('input', () => {
        let v = cep.value.replace(/\D/g, '').slice(0, 8);
        if (v.length > 5) v = v.slice(0, 5) + '-' + v.slice(5);
        cep.value = v;
      });
    }

    function escapeHtml(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
      }[c]));
    }

    function renderShippingRates(rates, via) {
      if (Array.isArray(rates) && rates.length > 0) {
        const items = rates.map((rate) =>
          '<li><span>' + escapeHtml(rate.presentment_name || rate.name) + '</span><span>R$ ' +
          Number(rate.price).toFixed(2).replace('.', ',') + '</span></li>'
        ).join('');
        results.innerHTML = '<ul>' + items + '</ul>';
      } else {
        results.innerHTML = '<span class="is-muted">Nenhuma opção de frete para ' +
          escapeHtml(via.localidade) + '/' + escapeHtml(via.uf) + '.</span>';
      }
    }

    // Polling das cotações assíncronas — carriers (ex.: Mandaê) respondem
    // depois do prepare. O endpoint retorna null enquanto ainda calcula.
    function pollShippingRates(via, attempt) {
      fetch(root_url + 'cart/async_shipping_rates.json', { headers: { 'Accept': 'application/json' } })
        .then((r) => r.json())
        .then((data) => {
          if (data === null || (data && data.shipping_rates === null)) {
            if (attempt < 20) {
              setTimeout(() => pollShippingRates(via, attempt + 1), 500);
            } else {
              results.innerHTML = '<span class="is-muted">O cálculo do frete demorou. Tente novamente.</span>';
            }
            return;
          }
          renderShippingRates(data.shipping_rates, via);
        })
        .catch((err) => {
          console.error('[riza-cart] async_shipping_rates falhou:', err);
          results.innerHTML = '<span class="is-muted">Não foi possível calcular o frete agora.</span>';
        });
    }

    if (calcBtn) {
      calcBtn.addEventListener('click', () => {
        const zip = (cep.value || '').replace(/\D/g, '');
        if (zip.length !== 8) {
          results.innerHTML = '<span class="is-muted">Digite um CEP válido (8 dígitos).</span>';
          return;
        }
        results.innerHTML = '<span class="is-muted">Calculando…</span>';

        // 1) Descobre o estado (UF) a partir do CEP — a Shopify exige o endereço
        // completo (país + estado + CEP) para cotar o frete no Brasil.
        fetch('https://viacep.com.br/ws/' + zip + '/json/')
          .then((r) => r.json())
          .then((via) => {
            if (!via || via.erro || !via.uf) {
              results.innerHTML = '<span class="is-muted">CEP não encontrado. Confira o número.</span>';
              return;
            }

            // 2) Prepara as cotações (dispara os carriers, ex.: Mandaê) e faz
            // polling do resultado assíncrono. O endpoint síncrono retornava
            // só a primeira opção; o async devolve TODAS as opções.
            const addr = 'shipping_address[zip]=' + encodeURIComponent(zip) +
              '&shipping_address[country]=Brazil' +
              '&shipping_address[province]=' + encodeURIComponent(via.uf);

            return fetch(root_url + 'cart/prepare_shipping_rates.json?' + addr, {
              method: 'POST',
              headers: { 'Accept': 'application/json' }
            }).then((r) => {
              if (r.ok) {
                pollShippingRates(via, 0);
                return;
              }
              // Erro no preparo (endereço) — mostra a causa real
              return r.json().catch(() => null).then((data) => {
                let msg = 'Não foi possível calcular o frete.';
                if (data && typeof data === 'object') {
                  const k = Object.keys(data)[0];
                  if (k && Array.isArray(data[k]) && data[k][0]) msg = data[k][0];
                  else if (data.message) msg = data.message;
                }
                console.error('[riza-cart] prepare_shipping_rates erro:', data);
                results.innerHTML = '<span class="is-muted">' + escapeHtml(msg) + '</span>';
              });
            });
          })
          .catch((err) => {
            console.error('[riza-cart] cálculo de frete falhou:', err);
            results.innerHTML = '<span class="is-muted">Não foi possível calcular o frete agora.</span>';
          });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["riza-product-accordions"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.riza-pacc__head').forEach((head) => {
      head.addEventListener('click', () => {
        const item = head.closest('.riza-pacc__item');
        const open = item.classList.toggle('is-open');
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    // Abas do kit (um produto por aba)
    document.querySelectorAll('.riza-pacc__tab').forEach((tab) => {
      tab.addEventListener('click', () => {
        const section = tab.closest('.riza-pacc');
        if (!section) return;
        const idx = tab.dataset.tab;
        section.querySelectorAll('.riza-pacc__tab').forEach((t) => {
          const active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        section.querySelectorAll('.riza-pacc__group').forEach((g) => {
          g.classList.toggle('is-active', g.dataset.panel === idx);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["riza-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.riza-product').forEach((root) => {
      // Acordeão "Aplicação" (acima do frete) — toggle próprio para não depender da seção de detalhes
      root.querySelectorAll('.riza-product__app-head').forEach((head) => {
        head.addEventListener('click', () => {
          const item = head.closest('.riza-pacc__item');
          if (!item) return;
          const open = item.classList.toggle('is-open');
          head.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });

      // Galeria (produtos com mais de uma imagem). Quem se desloca é sempre o
      // viewport: as miniaturas só rolam até o slide e o scroll-snap faz o
      // resto — inclusive no swipe do celular.
      const gal = root.querySelector('[data-gal]');
      if (gal) {
        const viewport = gal.querySelector('[data-gal-viewport]');
        const slides = Array.from(gal.querySelectorAll('.riza-gal__slide'));
        const thumbs = Array.from(gal.querySelectorAll('[data-gal-thumb]'));
        let index = 0;
        // Enquanto a rolagem programada acontece, o evento de scroll passa por
        // slides intermediários; sem esta trava o índice voltaria atrás e a
        // miniatura seguinte marcaria a foto errada.
        let lockUntil = 0;

        // Distância de um slide ao outro — medida, não deduzida da largura do
        // viewport, para o passo continuar certo se um dia houver gap.
        function step() {
          if (slides.length > 1) {
            const d = slides[1].offsetLeft - slides[0].offsetLeft;
            if (d > 0) return d;
          }
          return viewport.clientWidth || 1;
        }

        const live = gal.querySelector('[data-gal-live]');
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        function nearestIndex() {
          return Math.max(0, Math.min(slides.length - 1, Math.round(viewport.scrollLeft / step())));
        }

        function render() {
          // Não há contador nem setas: este texto é o que conta a troca de
          // foto para quem usa leitor de tela.
          if (live) live.textContent = 'Imagem ' + (index + 1) + ' de ' + slides.length;
          thumbs.forEach((t, n) => t.classList.toggle('is-active', n === index));
        }

        function mark(i) {
          if (i === index) return;
          index = i;
          render();
        }

        function goTo(i) {
          // Sem dar a volta: chegou na última, acabou. Dar a volta confundiria
          // com um carrossel infinito.
          const n = Math.max(0, Math.min(slides.length - 1, i));
          lockUntil = Date.now() + 600;
          viewport.scrollTo({ left: n * step(), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
          mark(n);
        }

        let ticking = false;
        viewport.addEventListener('scroll', () => {
          if (ticking || Date.now() < lockUntil) return;
          ticking = true;
          requestAnimationFrame(() => {
            ticking = false;
            mark(nearestIndex());
          });
        }, { passive: true });

        thumbs.forEach((thumb, n) => thumb.addEventListener('click', () => goTo(n)));

        // Arrastar com o mouse ou com o dedo. A foto acompanha o ponteiro 1:1 e,
        // ao soltar, decide pelo conjunto distância + velocidade: um gesto
        // curto e rápido já troca de foto (puxar meia tela seria cansativo).
        const DRAG_RATIO = 0.14;   // 14% da largura de um slide já basta
        const FLICK_SPEED = 0.4;   // px/ms — um peteleco rápido também troca
        let dragging = false;
        let moved = false;
        let startX = 0;
        let startScroll = 0;
        let lastX = 0;
        let lastT = 0;
        let speed = 0;
        let settleTimer = null;

        viewport.addEventListener('pointerdown', (e) => {
          moved = false;
          // No dedo o scroll nativo é melhor do que qualquer inércia em JS
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          dragging = true;
          moved = false;
          speed = 0;
          startX = lastX = e.clientX;
          lastT = e.timeStamp;
          startScroll = viewport.scrollLeft;
          clearTimeout(settleTimer);
          viewport.classList.remove('is-settling');
          viewport.classList.add('is-grabbing');
          viewport.setPointerCapture(e.pointerId);
        });

        viewport.addEventListener('pointermove', (e) => {
          if (!dragging) return;
          const dx = e.clientX - startX;
          if (Math.abs(dx) > 4) moved = true;
          const dt = e.timeStamp - lastT;
          if (dt > 0) {
            // média móvel: um único quadro ruim não decide o gesto
            speed = speed * 0.7 + ((e.clientX - lastX) / dt) * 0.3;
            lastX = e.clientX;
            lastT = e.timeStamp;
          }
          viewport.scrollLeft = startScroll - dx;
          // A foto que vai vencer já acende durante o arrasto: sem isto ela
          // fica apagada ocupando a tela toda e "estala" ao soltar.
          mark(nearestIndex());
        });

        function endDrag(e) {
          if (!dragging) return;
          dragging = false;
          viewport.classList.remove('is-grabbing');
          if (viewport.hasPointerCapture && viewport.hasPointerCapture(e.pointerId)) {
            viewport.releasePointerCapture(e.pointerId);
          }
          if (!moved) return;

          const st = step();
          const dx = viewport.scrollLeft - startScroll;   // positivo = foi para a direita
          // Ponteiro parado antes de soltar não é peteleco: a média móvel
          // guardaria a última velocidade e trocaria de foto sozinha.
          if (e.timeStamp - lastT > 90) speed = 0;
          // O índice atual é a origem, não a conta do scroll: em dois arrastos
          // seguidos o segundo pega o scroll no meio da acomodação do primeiro.
          const from = index;
          let target = from;
          if (Math.abs(dx) > st * DRAG_RATIO) {
            target = dx > 0 ? from + 1 : from - 1;
          } else if (Math.abs(speed) > FLICK_SPEED) {
            // speed > 0 = ponteiro indo para a direita = foto anterior
            target = speed < 0 ? from + 1 : from - 1;
          }
          target = Math.max(0, Math.min(slides.length - 1, target));

          // O snap só volta depois que a foto acomodou, senão ele corta a
          // animação no meio.
          viewport.classList.add('is-settling');
          lockUntil = Date.now() + 600;
          viewport.scrollTo({ left: target * st, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
          mark(target);
          settleTimer = setTimeout(() => viewport.classList.remove('is-settling'), 700);
        }

        viewport.addEventListener('pointerup', endDrag);

        // Gesto cancelado (o navegador assumiu a rolagem, por exemplo) volta
        // para onde estava em vez de comitar uma troca que ninguém pediu.
        viewport.addEventListener('pointercancel', () => {
          if (!dragging) return;
          dragging = false;
          moved = false;
          viewport.classList.remove('is-grabbing');
          viewport.scrollLeft = index * step();
        });

        // O clique que fecha o arrasto não pode contar como clique na foto
        viewport.addEventListener('click', (e) => {
          if (moved) { e.stopPropagation(); e.preventDefault(); }
        }, true);
        viewport.addEventListener('dragstart', (e) => e.preventDefault());

        viewport.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index - 1); }
        });

        // Ao girar o aparelho a largura muda e o scroll fica no meio de dois
        // slides. Só reagimos à largura: no celular a
        // barra de endereço recolhendo dispara resize durante a rolagem.
        let lastW = window.innerWidth;
        let resizeTimer = null;
        window.addEventListener('resize', () => {
          if (window.innerWidth === lastW) return;
          lastW = window.innerWidth;
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => {
            viewport.classList.add('is-settling');
            viewport.scrollLeft = index * step();
            requestAnimationFrame(() => viewport.classList.remove('is-settling'));
          }, 120);
        });

        render();
      }

      // Quantidade
      const qtyInput = root.querySelector('.riza-product__qty-input');
      root.querySelectorAll('.riza-product__qty-btn').forEach((btn) => {
        btn.addEventListener('click', () => {
          const step = parseInt(btn.dataset.step, 10);
          const next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + step);
          qtyInput.value = next;
        });
      });

      // Kit/bundle: adiciona os 2 componentes reais e vai para /cart
      const bundleBtn = root.querySelector('.riza-product__bundle-btn');
      if (bundleBtn) {
        bundleBtn.addEventListener('click', () => {
          if (bundleBtn.disabled) return;
          const rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          const ids = (bundleBtn.dataset.components || '')
            .split(',').map((s) => parseInt(s.trim(), 10)).filter((n) => n > 0);
          if (!ids.length) return;
          const qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
          // Componentes como linhas normais (sem property) — o carrinho agrupa
          // num bloco de kit por detecção dos componentes.
          const items = ids.map((id) => ({ id: id, quantity: qty }));

          if (!bundleBtn.dataset.label) bundleBtn.dataset.label = bundleBtn.textContent.trim();
          bundleBtn.disabled = true;
          bundleBtn.textContent = 'Adicionando…';

          fetch(rootUrl + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          })
            .then((r) => r.json().then((data) => ({ ok: r.ok, data: data })))
            .then((res) => {
              if (res.ok) { window.location.href = rootUrl + 'cart'; return; }
              bundleBtn.disabled = false;
              bundleBtn.textContent = 'Estoque insuficiente';
              setTimeout(() => { bundleBtn.textContent = bundleBtn.dataset.label; }, 2500);
            })
            .catch(() => {
              bundleBtn.disabled = false;
              bundleBtn.textContent = bundleBtn.dataset.label;
            });
        });
      }

      // Frete
      const shipToggle = root.querySelector('.riza-product__ship-toggle');
      const shipBody = root.querySelector('.riza-product__ship-body');
      if (shipToggle && shipBody) {
        shipToggle.addEventListener('click', () => {
          const open = shipBody.hasAttribute('hidden');
          if (open) { shipBody.removeAttribute('hidden'); } else { shipBody.setAttribute('hidden', ''); }
          shipToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }

      const cep = root.querySelector('.riza-product__cep');
      const calcBtn = root.querySelector('.riza-product__ship-calc');
      const results = root.querySelector('.riza-product__ship-results');

      if (cep) {
        cep.addEventListener('input', () => {
          let v = cep.value.replace(/\D/g, '').slice(0, 8);
          if (v.length > 5) v = v.slice(0, 5) + '-' + v.slice(5);
          cep.value = v;
        });
      }

      if (calcBtn) {
        calcBtn.addEventListener('click', () => {
          const zip = (cep.value || '').replace(/\D/g, '');
          if (zip.length !== 8) {
            results.innerHTML = '<span class="is-muted">Digite um CEP válido (8 dígitos).</span>';
            return;
          }
          results.innerHTML = '<span class="is-muted">Calculando…</span>';
          const root_url = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          const url = root_url + 'cart/shipping_rates.json?shipping_address[zip]=' +
            encodeURIComponent(zip) + '&shipping_address[country]=Brazil';

          fetch(url, { headers: { 'Accept': 'application/json' } })
            .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
            .then(({ ok, data }) => {
              const rates = data && data.shipping_rates;
              if (!ok || !rates || rates.length === 0) {
                results.innerHTML = '<span class="is-muted">Adicione o produto ao carrinho para calcular o frete, ou nenhuma opção foi encontrada para este CEP.</span>';
                return;
              }
              const items = rates.map((rate) =>
                '<li><span>' + rate.name + '</span><span>R$ ' +
                Number(rate.price).toFixed(2).replace('.', ',') + '</span></li>'
              ).join('');
              results.innerHTML = '<ul>' + items + '</ul>';
            })
            .catch(() => {
              results.innerHTML = '<span class="is-muted">Não foi possível calcular o frete agora.</span>';
            });
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["riza-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const rows = document.querySelectorAll('.riza-reviews__row');

    rows.forEach((row) => {
      let isDown = false;
      let startX = 0;
      let startScroll = 0;
      let moved = false;

      row.addEventListener('pointerdown', (e) => {
        // Apenas mouse: no toque, deixamos a rolagem nativa (fluida, sem pulos)
        if (e.pointerType !== 'mouse') return;
        if (e.button !== 0) return;
        isDown = true;
        moved = false;
        startX = e.clientX;
        startScroll = row.scrollLeft;
      });

      row.addEventListener('pointermove', (e) => {
        if (!isDown) return;
        const walk = e.clientX - startX;
        if (Math.abs(walk) > 4) {
          moved = true;
          row.classList.add('is-dragging');
          row.setPointerCapture(e.pointerId);
        }
        if (moved) {
          row.scrollLeft = startScroll - walk;
        }
      });

      const stop = () => {
        isDown = false;
        row.classList.remove('is-dragging');
      };

      row.addEventListener('pointerup', stop);
      row.addEventListener('pointercancel', stop);
      row.addEventListener('pointerleave', stop);

      // Evita que o "soltar" no fim do arraste dispare o clique do card
      row.addEventListener('click', (e) => {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);

      // Roda do mouse (vertical) rola o carrossel na horizontal — fluido no desktop
      row.addEventListener('wheel', (e) => {
        if (e.deltaY === 0) return;
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return; // já é gesto horizontal
        const max = row.scrollWidth - row.clientWidth;
        if (max <= 0) return; // nada a rolar
        const atStart = row.scrollLeft <= 0;
        const atEnd = row.scrollLeft >= max - 1;
        // nas bordas, deixa a página rolar normalmente
        if ((e.deltaY < 0 && atStart) || (e.deltaY > 0 && atEnd)) return;
        e.preventDefault();
        row.scrollLeft += e.deltaY;
      }, { passive: false });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
